import angular from 'angular';

require('textangular/dist/textAngular-sanitize.min');


(function () {
    'use strict';

    angular.module('app.announcement', [
        require('angular-sanitize'),
        'textAngular'
    ]);
})();
